<template>
  <v-container id="layout-container" fluid :class="'pa-0' + (alignTop ? ' align-start' : ' align-center')">
    <v-row justify="center" class="pa-lg-3" no-gutters>
      <!-- navigation -->
      <v-col
        ref="navigation"
        id="layout-navigation"
        v-if="showNav"
        :order="navigationOrders[currentBreakpoint]"
        :cols="navigationCols[currentBreakpoint]"
        :class="'pa-1'">
        <v-card rounded="lg" class="pa-2">
          <slot name="content-left" />
        </v-card>
      </v-col>

      <!-- content -->
      <v-col
        id="layout-content"
        style="position: relative; height: min-content"
        :order="contentOrders[currentBreakpoint]"
        :cols="contentCols[currentBreakpoint]"
        class="pa-1">
        <v-card id="layout-wrapper" rounded="lg" class="pa-2 fill-height" style="overflow: auto; display: flex; flex-direction: column">
          <slot name="content-center" />
        </v-card>
      </v-col>

      <!-- sort / filter -->
      <v-col id="layout-search" v-if="showSort" :order="sortOrders[currentBreakpoint]" :cols="sortCols[currentBreakpoint]" :class="'pa-1'">
        <v-card rounded="lg" class="pa-2">
          <slot name="content-right" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Responsive from '@/mixins/responsive.js';

import { mapGetters } from 'vuex';
import { GET_SESSIONDATA } from '@/store/storeMutator';
export default {
  name: 'Layout',

  mixins: [Responsive],

  props: {
    showNav: Boolean,
    showSort: Boolean,
    alignTop: Boolean,
  },

  async mounted() {
    await this.setHeight();
  },

  //disconnect the observer before destroy
  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  },

  methods: {
    async setHeight() {
      /*
      Here the property divNav.style.maxHeight must be set to nothing,
      because for whatever reason the height values are transferred from the content div to the navigation div
      (I have spent hours looking at why this happens, I haven't found a solution or possible trigger for this.
      so i came up with this hacky solution...)
      */
      await this.$nextTick();
      var divNav = document.getElementById('layout-navigation');
      if (divNav) {
        divNav.style.maxHeight = '';
      }
      await this.$nextTick();

      var contentLayoutElem = document.getElementById('layout-content');
      var contentWrapperElem = document.getElementById('layout-wrapper');
      var contentNavbarElem = document.getElementById('layout-navigation');

      if (!contentLayoutElem || !contentWrapperElem || !contentNavbarElem) return;

      var searchHeight = await this.searchHeight();

      var paddingContentArea = '8px'; // 4px top, 4px bottom
      var paddingContentContainer = '24px'; // 12px top, 12px bottom

      var navHeight = contentNavbarElem.offsetHeight;

      console.log('Currentbreakpoint: ', this.currentBreakpoint);

      var contentLayoutCssString =
        this.currentBreakpoint === 4
          ? `calc(100vh - ${paddingContentContainer})`
          : `calc((100vh - ${paddingContentArea} - ${paddingContentArea}) - (${navHeight}px + ${
              searchHeight ? searchHeight : 0
            }px))`;

      contentLayoutElem.style.maxHeight = contentLayoutCssString;
      contentWrapperElem.style.maxHeight = contentLayoutCssString;
      console.log('contentLayoutCssStringt --> ', contentLayoutCssString);
      console.log('contentWrapperElem.style.maxHeight --> ', contentWrapperElem.style.maxHeight);
    },
  },

  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    ...mapGetters({ SessionData: GET_SESSIONDATA }),
  },

  watch: {
    async showNav() {
      if (!this.observer) {
        await this.$nextTick();
        this.initNavAreaObserver(this.$refs.navigation);
      }

      await this.setHeight();
    },
    async showSort() {
      await this.setHeight();
    },
    async breakpoint() {
      await this.setHeight();
    },
  },
};
</script>

<style global>
.mh-overview-content {
  /*
   * in order for the interface to adapt to the size of the iFrame/viewport, some paddings and element heights must be subtracted
   * 41px   ->    removing (top and bottom) paddings 
  */
  --additional-subtraction: 0px;
  max-height: calc(100vh - 41px - var(--additional-subtraction));
  overflow-y: auto;
  overflow-x: hidden;
}

/**
does not set margin to 0px, because spacing is needed
*/
.nomargin-firstchild > div:first-child {
  margin-top: 4px !important;
}

/**
does not set margin to 0px, because spacing is needed
*/
.nomargin-lastchild > div:last-child {
  margin-bottom: 4px !important;
}

.fade-enter-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
